import React, { FC, useState } from 'react'
import Modal from './Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDispatch } from 'react-redux'
import { updateServiceRequest } from '../../../states/containers/common/commonPartSlice'

interface Props {
  display: boolean,
  closeCallback: () => void
}

const ApiRequestModal: FC<Props> = (props) => {
  const dispatch = useDispatch()

  const {
    display,
    closeCallback,
  } = props

  const [isDisplayRequest, setIsDisplayRequest] = useState<boolean>(false)
  const [isRequestLoading, setIsRequestLoading] = useState<boolean>(false)
  const [isRequestSuccess, setIsRequestSuccess] = useState<boolean>(false)

  const closeModal = () => {
    setIsDisplayRequest(false)
    setIsRequestSuccess(false)
    setIsRequestLoading(false)
    closeCallback()
  }

  const submit = () => {
    setIsRequestLoading(true)
    dispatch(
      updateServiceRequest(
        {
          request_type: "API連携機能",
        },
        () => {
          setIsRequestSuccess(true)
          setIsRequestLoading(false)
        },
      ),
    )
  }

  const requestButton = () => (
    <button
      type="button"
      style={{
        width: "620px",
        backgroundColor: "#4472BA",
        border: "solid 3px #FFFFFF",
        borderRadius: "12px",
        color: "#FFFFFF",
        boxShadow: "4px 4px 6px #CCCCCC",
        padding: "24px 40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={() => setIsDisplayRequest(true)}
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "50px",
          fontSize: "22px",
          color: "#4472BA",
          padding: "8px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
      >
        API連携機能に関するご相談はこちら
        <FontAwesomeIcon icon={['fas', 'play']} style={{ fontSize: "16px" }} />
      </div>
    </button>
  )

  return (
    <>
      <Modal
        modalSize="lp"
        show={display}
        closeCallback={closeModal}
        closeable
        wrapperClass=""
      >
        <>
          <div
            style={{
              userSelect: "none",
              color: "#666666",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "calc(100% + 64px)",
                margin: "-32px",
                backgroundColor: "#4472BA1A",
                display: "flex",
                flexFlow: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "40px",
                padding: "64px",
              }}
            >
              <div
                style={{
                  fontSize: "26px",
                }}
              >
                <span style={{ color: "#4472BA" }}>Qasee</span>
                とシステムを繋げて、
                <span style={{ color: "#4472BA" }}>Qasee</span>
                をより便利に
              </div>
              <div
                style={{
                  fontSize: "50px",
                  fontWeight: "bold",
                  color: "#4472BA",
                }}
              >
                API連携機能
              </div>
              <div
                style={{
                  fontSize: "20px",
                  display: "flex",
                  flexFlow: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                  letterSpacing: "0.05em",
                  color: "#777777",
                }}
              >
                <div>
                  QaseeAPIを活用して、Qaseeと各種システムを連携します。
                </div>
                <div>
                  ※API連携には専門知識が必要です。社内の技術担当者にご確認ください。
                </div>
              </div>
              {requestButton()}
              <img
                alt=""
                src="/static/images/api_request/image_1.png"
                style={{
                  position: "absolute",
                  left: "40px",
                  bottom: 0,
                  height: "390px",
                }}
              />
            </div>
          </div>
        </>
      </Modal>
      <Modal
        show={isDisplayRequest}
        closeCallback={() => setIsDisplayRequest(false)}
        closeable
        wrapperClass=""
      >
        <>
          {
            isRequestSuccess ? (
              <>
                <div
                  style={{
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "4px",
                    fontSize: "18px",
                    marginBottom: "24px",
                  }}
                >
                  <div>
                    API連携機能に関するご相談リクエストを受け付けました。
                  </div>
                  <div>
                    Qasee カスタマーサクセスより順次ご連絡致します。
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "16px",
                    gap: "8px",
                  }}
                >
                  <button
                    type="button"
                    className="button cancel"
                    onClick={closeModal}
                    style={{
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #656E73",
                      color: "#656E73",
                      width: "200px",
                      textAlign: "center",
                      borderRadius: "4px",
                    }}
                  >
                    閉じる
                  </button>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "4px",
                    fontSize: "18px",
                    marginBottom: "24px",
                  }}
                >
                  <div>
                    API連携機能に関するご相談リクエストを送信します。
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "16px",
                    gap: "8px",
                  }}
                >
                  <button
                    type="button"
                    className="button cancel"
                    onClick={() => setIsDisplayRequest(false)}
                    style={{
                      backgroundColor: "#FFFFFF",
                      border: "1px solid #656E73",
                      color: "#656E73",
                      width: "200px",
                      textAlign: "center",
                      borderRadius: "4px",
                    }}
                  >
                    キャンセル
                  </button>
                  <button
                    type="button"
                    className="button"
                    onClick={submit}
                    style={{
                      backgroundColor: "#1630c6",
                      border: "1px solid #1630c6",
                      color: "#FFFFFF",
                      width: "200px",
                      textAlign: "center",
                      borderRadius: "4px",
                    }}
                    disabled={isRequestLoading}
                  >
                    {
                      isRequestLoading ? (
                        <>
                          <FontAwesomeIcon icon={['fas', 'spinner']} spin />
                        </>
                      ) : (
                        <>
                          リクエストを送信する
                        </>
                      )
                    }
                  </button>
                </div>
              </>
            )
          }
        </>
      </Modal>
    </>
  )
}

export default ApiRequestModal
